export function createProductionRequestGuard(initialSeq = 0) {
  let seq = initialSeq;

  const bump = () => {
    seq += 1;
    return seq;
  };

  const current = () => seq;

  const isLatest = (requestSeq) => requestSeq === seq;

  const resolveNextState = (prevState, nextState) =>
    typeof nextState === 'function' ? nextState(prevState) : nextState;

  const setStateIfLatest = (requestSeq, prevState, nextState) => {
    if (!isLatest(requestSeq)) return null;
    return resolveNextState(prevState, nextState);
  };

  return {
    bump,
    current,
    isLatest,
    setStateIfLatest,
    resolveNextState
  };
}
